/*!
 * @monogrid/vue-boost v1.2.0 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { defineComponent as d, computed as n } from "vue";
import { getEnv as o } from "../../index2.mjs";
const g = d({
  name: "VersionInfo",
  props: {
    autoPositioned: {
      type: Boolean,
      required: !1,
      default: !0
    },
    copyOnClick: {
      type: Boolean,
      required: !1,
      default: !0
    },
    gitTag: {
      type: String,
      required: !1,
      default: () => o().GIT_VERSION
    },
    gitHash: {
      type: String,
      required: !1,
      default: () => o().GIT_HASH
    },
    gitBranch: {
      type: String,
      required: !1,
      default: () => o().GIT_BRANCH
    }
  },
  setup(e) {
    const t = n(() => `v${e.gitTag} ${e.gitHash} ${e.gitBranch}`), r = n(() => ({
      padding: "4px",
      backgroundColor: "#000",
      color: "#fff",
      fontSize: "0.5rem",
      fontWeight: "bold",
      cursor: "pointer",
      ...e.autoPositioned ? { position: "fixed", zIndex: 1e4, right: 0, bottom: 0 } : {}
    }));
    return {
      text: t,
      style: r,
      onClick: () => {
        if (console.log(`[VERSION] ${t.value}`), !e.copyOnClick)
          return;
        const i = "text/plain", a = new Blob([t.value], { type: i });
        if ("clipboard" in navigator) {
          const l = [new ClipboardItem({ [i]: a })];
          navigator.clipboard.write(l).then(() => alert(`'${t.value}' copied to clipboard!`)).catch((c) => console.error(c));
        }
      }
    };
  }
});
export {
  g as VersionInfo,
  g as default
};
